import React from "react";
import PropTypes from "prop-types";
import moment from "moment-timezone";

import SVGIcon from "common/SVGIcon";
import { applicationShape } from "lib/propTypes";

export default class Interviews extends React.PureComponent {
    static propTypes = {
        interviews: PropTypes.arrayOf(PropTypes.shape(applicationShape)).isRequired,
    };

    renderInterviews() {
        if (this.props.interviews.length === 0) {
            return <span className="cand-home__interviews-empty">No upcoming interviews</span>;
        }
        return this.props.interviews.map((app) => (
            <div className="cand-home__interviews-row" key={app.id}>
                {this.renderDate(app.time_interview_schedule)}
                <div className="cand-home__interviews-position-info">
                    <p className="cand-home__interviews-position">{app.position.title}</p>
                    <p>{app.position.company_name}</p>
                    <p>
                        <span>{moment(app.time_interview_schedule).format("h:mma z")},</span>{" "}
                        {app.position.interview_type.middle.replace(/^\w/, (c) => c.toUpperCase())}
                    </p>
                </div>
                <a href={`${app.schedule_url}?v`} className="cand-home__interviews-reschedule-link">
                    <p className="secondary-text-link">Reschedule / cancel</p>
                    <SVGIcon icon="chevron-right" />
                </a>
            </div>
        ));
    }

    renderDate(time) {
        const today = moment();
        const tomorrow = moment().add(1, "day");
        const interview = moment(time);

        if (today.isSame(interview, "day")) {
            return (
                <div className="cand-home__interviews-date">
                    <p className="home-important-text">Today</p>
                </div>
            );
        }

        if (tomorrow.isSame(interview, "day")) {
            return (
                <div className="cand-home__interviews-date">
                    <p className="home-important-text">Tomorrow</p>
                </div>
            );
        }

        return (
            <div className="cand-home__interviews-date">
                <p className="home-important-text">{moment(time).format("MMM D")}</p>
                <span>{moment(time).format("ddd")}</span>
            </div>
        );
    }

    render() {
        return (
            <section className="cand-home__interviews">
                <h1 className="section-title">Interviews</h1>
                {this.renderInterviews()}
            </section>
        );
    }
}
